import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Position } from '@blueprintjs/core';
import { ShowHide } from 'components/layout';
import { Tooltip } from 'components/tooltip';

const removedInfringementText = "This infringement has since been removed from the system.";

// Marks an infringement that has been deleted from the driver's record since the review recorded it.
export function RemovedInfringementIcon({ item }) {
    return (
        <ShowHide
            evaluator={item.infringementDeleted === true}
            show={(
                <Tooltip content={removedInfringementText} position={Position.TOP}>
                    <Icon
                        icon="warning-sign"
                        color="#F0578A"
                        role="img"
                        aria-hidden={false}
                        aria-label={removedInfringementText}
                    />
                </Tooltip>
            )}
        />
    );
}

RemovedInfringementIcon.propTypes = {
    item: PropTypes.object.isRequired
};
